import { Link } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';
import '../styles/Navbar.css';
import logo from '../assets/logo.png'; 
import { IconSun, IconMoon } from '@tabler/icons-react';


export function Navbar() {
  const { theme, toggleTheme } = useTheme();

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="Ephemail" className="navbar-logo" />
          <span>Ephemail</span>
        </Link>
      </div>

      <div className="navbar-right">
        <Link to="/">Home</Link>
        <Link to="/generated">Generate</Link>
        <Link to="/api-docs">API Docs</Link>
        <Link to="/email-client">Ephemail.TestKit</Link>

        <button className="theme-switcher" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'light' ? <IconMoon size={24} stroke={1.5} /> : <IconSun size={24} stroke={1.5} />}
        </button>

      </div>
    </nav>
  );
}
